import { useRef } from "react";
import classnames from "classnames";
import CloseIcon from "../icons/close";
import ChevronLeftIcon from "../icons/chevron-left";
import { target } from "../lib/target";
import css from "./widget-titlebar.module.css";
import useWidgetContext from "./widget-context";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WidgetTitlebar = ({
  channel = "MSEM",
  close,
  goBack,
  noTitlebar,
  onStartDrag,
  onDrag,
  environments,
  environmentChanged
}) => {
  const {
    options
  } = useWidgetContext();
  const titleBarRef = useRef(null);
  const drag = e => {
    onDrag(e);
  };
  const onMouseDown = e => {
    if (!options.draggable) return;
    const x = e.clientX;
    const y = e.clientY;
    onStartDrag(x, y);
    document.addEventListener("mousemove", drag);
    document.addEventListener("mouseup", onMouseUp);
    titleBarRef.current.style.cursor = "move";
  };
  const onMouseUp = e => {
    document.removeEventListener("mouseup", onMouseUp);
    document.removeEventListener("mousemove", drag);
    titleBarRef.current.style.cursor = "inherit";
  };
  const logoUrl = `https://widget.msem.tech/images/channel/${channel}.svg`;
  const backClicked = () => goBack && goBack();
  const barClasses = classnames(css.titlebar, {
    [css.noTitlebar]: noTitlebar
  });
  const backClasses = classnames(css.icon, css.back, {
    [css.noTitlebar]: noTitlebar
  });
  const closeClasses = classnames(css.icon, css.close);
  const selectedEnv = target();
  const multiEnvs = environments.length > 1;
  return _jsxs("div", {
    ref: titleBarRef,
    className: barClasses,
    onMouseDown: onMouseDown,
    children: [goBack && _jsx(ChevronLeftIcon, {
      className: backClasses,
      onClick: backClicked
    }), !noTitlebar && _jsxs(_Fragment, {
      children: [_jsx("img", {
        className: css.logo,
        src: logoUrl,
        alt: ""
      }), multiEnvs && _jsx("select", {
        className: css.envSelector,
        onChange: environmentChanged,
        value: selectedEnv,
        children: environments.map(env => _jsx("option", {
          value: env,
          children: env
        }, env))
      }), _jsx(CloseIcon, {
        className: closeClasses,
        onClick: close
      })]
    })]
  });
};
export default WidgetTitlebar;